export default __webpack_public_path__ + "static/media/dvd.2dac1591.png";